export enum API_ACTIVITY_TYPE {
  SYNC_IN_PROGRESS = 'SYNC_IN_PROGRESS',
  SYNC_COMPLETED = 'SYNC_COMPLETED',
  SYNC_ERROR = 'SYNC_ERROR',
}

export enum API_ACTIVITY_STATUS {
  SYNC_IN_PROGRESS = 'IN PROGRESS',
  SYNC_COMPLETED = 'COMPLETED',
  SYNC_ERROR = 'ERROR',
}
